import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { StandardModal, ModalBody, ModalSize, ModalButtonType } from '../../Components/Fundamentals/Modal/StandardModal';
import DatePicker from '../../Components/Fundamentals/DatePicker';
import helpers from '../../Utils/helpers';
import commonActions from '../../Actions/commonActions';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

/**
 * Props:
 * @param {string} currentScheduledTime - The current scheduled time (ISO string)
 * @param {function} onClose - Callback when modal is closed/cancelled
 * @param {function} onSave - Callback when save is confirmed, receives the new scheduled time (ISO string) and a callback to call when done
 */
function EditScheduledTimeModal({ currentScheduledTime, onClose, onSave }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { showWarning } = bindActionCreators(commonActions, dispatch);
    
    const [newScheduledTime, setNewScheduledTime] = useState(currentScheduledTime);
    const [isLoading, setIsLoading] = useState(false);

    const handleDateChange = (date, dateObj) => {
        if (!dateObj) {
            setNewScheduledTime(null);
        } else if (dateObj > new Date()) {
            setNewScheduledTime(dateObj.toISOString());
        }
    };

    const handleSave = () => {
        if (!newScheduledTime) {
            showWarning(t('invoiceprocessing.invaliddate'));
            return;
        }
        
        const newTime = new Date(newScheduledTime);
        if (newTime <= new Date()) {
            showWarning(t('invoiceprocessing.mustbefuturedate'));
            return;
        }

        setIsLoading(true);
        onSave(newScheduledTime, () => {
            setIsLoading(false);
        });
    };

    return (
        <StandardModal
            title={t("invoiceprocessing.editScheduledTime")}
            size={ModalSize.LARGE}
            onClose={onClose}
            onSubmit={handleSave}
            type={ModalButtonType.SAVE}
            isLoading={isLoading}
        >
            <div className="d-flex flex-column gap-3 pt-24 pb-128">
                <div>
                    <label className="form-label">
                        <strong>{t("invoiceprocessing.currentScheduledTime")}:</strong>
                    </label>
                    <div>{helpers.formatDateAndTime(currentScheduledTime)}</div>
                </div>
                <div className="pt-16">
                    <label className="form-label">
                        <strong>{t("invoiceprocessing.newScheduledTime")}:</strong>
                    </label>
                    <DatePicker
                        showTime={true}
                        closeOnSelect={false}
                        onChange={handleDateChange}
                        value={newScheduledTime}
                        isValidDate={(current) => current.isAfter(moment())}
                        showTimezone={true}
                    />
                </div>
            </div>
        </StandardModal>
    );
}

export default EditScheduledTimeModal;

